var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.07 9.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#585858;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.59,2h-2.09l.35-1.17,1.44-.05.35,1.22h-.04ZM2.88,6.71c-.31-.78-.31-1.57,0-2.35.26-.7.83-1.26,1.52-1.57.35-.13.74-.22,1.13-.22s.74.09,1.13.22c.7.31,1.22.87,1.53,1.57.31.78.31,1.57,0,2.35-.31.7-.83,1.26-1.53,1.57-.74.31-1.52.31-2.26,0-.69-.3-1.26-.87-1.52-1.57h0ZM.61,2c-.35.05-.61.35-.61.69v5.67c0,.39.31.69.66.69h9.72c.39,0,.69-.31.69-.69V2.7c0-.39-.31-.69-.69-.69-.04-.22-.04-.52-.17-.65-.04-.05-.13-.05-.22-.05h-1.96c-.31,0-.31.39-.35.7h-.26l-.48-1.7c-.04-.17-.17-.31-.35-.31l-1.96.05c-.22,0-.35.09-.44.31l-.48,1.65H.61ZM6.85,4.22c-1.35-1.35-3.58-.13-3.23,1.74.31,1.7,2.49,2.18,3.45.7.52-.74.44-1.79-.22-2.44h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3105e88c55e7b981b4ae987eda1d163a.svg";
export { ForwardRef as ReactComponent };